<template>
  <div>
      <!-- 健康评价 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="健康评价">
            <div class="section-title">
              <i class="el-icon-menu" style="margin-right: 10px;"></i>健康评价
            </div>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="健康评价">
                  <el-radio-group v-model="formData.healthAss1" size="small">
                    <el-radio-button :label="1">体检无异常</el-radio-button>
                    <el-radio-button :label="2">体检有异常</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="异常1 新发">
                  <el-checkbox v-model="formData.healthAssXsxf" :true-label="'1'" :false-label="'0'">高血压</el-checkbox>
                  <el-checkbox v-model="formData.healthAssGxf" :true-label="'1'" :false-label="'0'">糖尿病</el-checkbox>
                  <el-checkbox v-model="formData.healthAssTxf" :true-label="'1'" :false-label="'0'">其他</el-checkbox>
                  <el-input v-model="formData.healthAssQtxf" placeholder="其他内容" v-if="formData.healthAssTxf === 1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="异常2">
                  <el-input v-model="formData.healthAss21" placeholder="异常内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="异常3">
                  <el-input v-model="formData.healthAss22" placeholder="异常内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="异常4">
                  <el-input v-model="formData.healthAss23" placeholder="异常内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="异常5">
                  <el-input v-model="formData.healthAss24" placeholder="异常内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="异常6">
                  <el-input v-model="formData.healthAss25" placeholder="异常内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="异常7" >
                  <el-input v-model="formData.healthAss26" placeholder="异常内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24" >
              <el-col :span="24">
                <el-form-item label="异常提示：（此内容不包含所有异常指标，仅供参考）">
                  <el-input type="textarea" v-model="formData.healthAssRemark" rows="5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>

      <!-- 健康指导 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="健康指导">
            <div class="section-title">
              <i class="el-icon-menu" style="margin-right: 10px;"></i>健康指导
            </div>

            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="健康指导">
                  <el-checkbox v-model="formData.healthGuidanceSlowDisease" :true-label="'1'" :false-label="'0'">纳入慢性病患者健康管理</el-checkbox>
                  <el-checkbox v-model="formData.healthGuidanceInhospital" :true-label="'1'" :false-label="'0'">建议住院</el-checkbox>
                  <el-checkbox v-model="formData.healthGuidanceReview" :true-label="'1'" :false-label="'0'">建议转诊</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="危险因素控制">
                  <el-checkbox v-model="formData.hazardQuitSmocking" :true-label="'1'" :false-label="'0'">戒烟</el-checkbox>
                  <el-checkbox v-model="formData.hazardHealthDrink" :true-label="'1'" :false-label="'0'">健康饮酒</el-checkbox>
                  <el-checkbox v-model="formData.hazardFood" :true-label="'1'" :false-label="'0'">饮食</el-checkbox>
                  <el-checkbox v-model="formData.hazardHardening" :true-label="'1'" :false-label="'0'">锻炼</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item>
                  <el-checkbox v-model="formData.hazardLoseWeight" :true-label="'1'" :false-label="'0'">减体重</el-checkbox>
                  <span style="margin-left: 20px;">目标</span>
                  <el-input v-model="formData.hazardLoseWeightTarget" placeholder="目标体重" style="width: 150px;" :disabled="!formData.hazardLoseWeight">
                    <template slot="append">KG</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item>
                  <div class="flex-center">
                      <el-checkbox v-model="formData.hazardVaccination" :true-label="'1'" :false-label="'0'">建议接种疫苗</el-checkbox>
                      <el-select v-model="formData.hazardVaccinationStr" placeholder="其他" style="width: 200px; margin-left: 20px;" :disabled="!formData.hazardVaccination">
                        <el-option v-for="item in hazardOthersDict" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                      </el-select>
                     <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'HAZARD_VACCINATION_STR_DICT')"></el-button>
                 </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item>
                  <el-checkbox v-model="formData.hazardOthers" :true-label="'1'" :false-label="'0'">其他</el-checkbox>
                  <el-select v-model="formData.hazardOthersStr" placeholder="请选择" style="width: 200px; margin-left: 20px;" :disabled="!formData.hazardOthers">
                    <el-option v-for="item in hazardOthersDict" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>

      <!-- 其他 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="其他">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="下次体检日期" >
                  <el-date-picker v-model="formData.medicalNextTime" type="date" placeholder="选择日期" ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="总检医师签字">
                  <el-input v-model="formData.mainDoctorsName" placeholder="医师姓名" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="formData.remark" placeholder="备注" rows="4"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>
  </div>
</template>

<script>
export default {
  name: 'MedicalOther',
  props: {
    formData: {
      type: Object,
      required: true
    },
    hazardOthersDict: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.section-title {
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 15px;
  color: #000;
}
.el-table >>> .el-table__header th {
  color: #000;
}
.flex-center{
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/medical-other.vue